import React from 'react'
import getMovieLink from '../../functions/getMovieLink'
import { getItemsWithInterscroller } from '../../functions/weischerHelpers'
import Translation from '../../General/Translation'
import MovieListItemContainer from './MovieListItemContainer'
import OverviewInterscroller from '../OverviewInterscroller'

const FilterResultsList = ({
    queryStringValues, 
    interscrollerWeischerAds, 
    interscrollerAdvertisements,
    attributeStyling, 
    additionalScrollName='', 
    items, 
    hiddenAttributes,
    itemsData, 
    isSingleMovie, 
    detailsStyling,
    isMobile,
    displaySidebarRight, 
    programOverviewListStyle,
    dayFilters,
    onSidebarRightOpen, 
    displaySidebarRightSecond, 
    onSidebarRightClose,  
    performancePageOpen, 
    activePerformance, 
    onOpenPerformancePage, 
    onClosePerformancePage, 
    translation, 
    moviesRoutesData,
    selectionId,
    activeSelection,
    activeDetailsItem, 
    ignoreAttributesForPerformanceFilter,
    overviewFilterIgnoreOnPerformances,
    onOpenDetails, 
    theme,
    onCloseDetails,
    informationStyling,
    hideCinemaSelector,
    clusterCinemaActive,
    stripeAppearance,
    clusterCinemaOption,
    activeCinema,
    posterStyling,
    currentCinemaType
}) => {
    const integer = Math.ceil(items.length/6) >= 4 ? 6 : 3
    const { interscrollerId, interscrollerType, itemsWithInterscroller } = getItemsWithInterscroller(items, interscrollerWeischerAds, interscrollerAdvertisements, integer)

    return (
        <div className="grid-site-wrapper">
            <div className="overview-grid">
                {0 === itemsWithInterscroller.length ? (
                    <h3 className="no-movie title-xlarge-theatre">
                        <Translation id="ThereCurrentlyNoFilmsTypes" trans={translation} />
                    </h3>
                ):(
                    <div className={"list-grid " + programOverviewListStyle}>
                        {itemsWithInterscroller.map((itemId, index) => {
                            if(interscrollerType && interscrollerId === itemId) {
                                return <OverviewInterscroller
                                    key={index}
                                    itemClass="movie-item"
                                    interscrollerType={interscrollerType}
                                    interscrollerWeischerAds={interscrollerWeischerAds}
                                    interscrollerAdvertisements={interscrollerAdvertisements}
                                    styles={{}}
                                />
                            } else {
                                return (
                                    <MovieListItemContainer
                                        informationStyling={informationStyling}
                                        attributeStyling={attributeStyling}
                                        programOverviewListStyle={programOverviewListStyle}
                                        stripeAppearance={stripeAppearance}
                                        ignoreAttributesForPerformanceFilter={ignoreAttributesForPerformanceFilter}
                                        overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                                        theme={theme}
                                        key={index}
                                        dayFilters={dayFilters}
                                        additionalScrollName={additionalScrollName}
                                        clusterCinemaActive={clusterCinemaActive}
                                        clusterCinemaOption={clusterCinemaOption}
                                        activeCinema={activeCinema}
                                        index={index}
                                        hiddenAttributes={hiddenAttributes}
                                        queryStringValues={queryStringValues}
                                        detailsStyling={detailsStyling}
                                        isMobile={isMobile}
                                        posterStyling={posterStyling}
                                        id={itemId}
                                        itemsData={itemsData}
                                        currentCinemaType={currentCinemaType}
                                        hideCinemaSelector={hideCinemaSelector}
                                        itemData={itemsData[itemId]}
                                        isSingleMovie={isSingleMovie}
                                        displaySidebarRight={displaySidebarRight}
                                        displaySidebarRightSecond={displaySidebarRightSecond}
                                        onSidebarRightOpen={onSidebarRightOpen}
                                        onSidebarRightClose={onSidebarRightClose}
                                        performancePageOpen={performancePageOpen}
                                        activePerformance={activePerformance}
                                        onOpenPerformancePage={onOpenPerformancePage}
                                        onClosePerformancePage={onClosePerformancePage}
                                        translation={translation}
                                        itemLink={getMovieLink(itemId, moviesRoutesData, translation)}
                                        selectionId={selectionId}
                                        activeSelection={activeSelection}
                                        activeDetailsItem={activeDetailsItem}
                                        onCloseDetails={onCloseDetails}
                                        onOpenDetails={onOpenDetails}
                                    />
                                )
                            }
                        })}
                    </div>
                )}
            </div>
        </div>
    )
}

export default FilterResultsList 